import { CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CanDeactivateGuard } from './shared/services/can-deactivate-guard.service';
import { MAT_DIALOG_REF_PROVIDER } from './shared/utils/dialog-ref-provider';

//import { HTTP_INTERCEPTORS } from '@angular/common/http';
//import { ApiInterceptorService } from './services/api-interceptor.service';

@NgModule({
  providers: [
    CurrencyPipe,
    Title,
    MAT_DIALOG_REF_PROVIDER,
    CanDeactivateGuard
  ]
})

//{
//   provide: HTTP_INTERCEPTORS,
//   useClass: ApiInterceptorService,
//   multi: true, // Add this line when using multiple interceptors.
// },
export class CoreModule {}
